<template>
  <div>
    <transition name="fade">
      <LoadingMask v-if="onload" />
    </transition>
    <div class="c-app" v-if="!onload">
      <TheSidebar />
      <div class="c-wrapper">
        <TheHeader />
        <div class="c-body">
          <b-overlay :show="$isLoading" rounded="sm" class="h-100">
            <main class="c-main">
              <CContainer fluid>
                <transition name="fade">
                  <router-view :key="$route.fullPath"></router-view>
                </transition>
              </CContainer>
            </main>
          </b-overlay>
        </div>
        <TheFooter />
      </div>
    </div>
  </div>
</template>

<script>
import TheSidebar from "./TheSidebar";
import TheHeader from "./TheHeader";
import TheFooter from "./TheFooter";
import { mapGetters } from "vuex";
import LoadingMask from "@/views/pages/LoadData";
import $ from "jquery";

export default {
  name: "TheContainer",
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
    LoadingMask,
  },
  computed: {
    ...mapGetters(["isLoading", "getBrandDetail"]),
  },
  data() {
    return {
      onload: true,
      isUseClass: true,
      firstPathFromPermission: "/welcome",
    };
  },
  watch: {
    "$route.fullPath": function () {
      this.checkRouter();
    },
  },
  methods: {
    getDataMockup() {
      let res = {
        detail: {
          userGUID: "ba849af4-de0a-4d56-85d6-66795a4cd1aa",
          username: "admin-dev@thanulux.com",
          firstname: "admin",
          lastname: "thanulux",
        },
      };
      this.$store.dispatch("setUserData", res.detail);
      let resBrand = {
        detail: [
          {
            id: 1,
            logo: "",
            name: "Thanulux",
            brandCode: "",
            colorThemeMain: "#fd7202",
            colorThemeSecondary: "#FFFFFF",
            createdTime: "2021-06-19T02:45:33+07:00",
            createdBy: "1",
            updatedTime: "2021-06-19T02:45:33+07:00",
            updatedBy: "1",
            active: true,
            planId: 1,
          },
        ],
      };
      this.$store.dispatch("setBrandList", resBrand.detail);
      var admin_brand_id = this.$route.query.brandID;
      if (!admin_brand_id) {
        this.$store.dispatch(
          "setCurrentBrandID",
          this.$store.getters.getBrandList()[0].id
        );
        this.$router.replace({
          path: this.firstPathFromPermission,
          query: { brandID: this.$store.getters.getBrandList()[0].id },
        });
      } else {
        let brandPermission = this.$store.getters
          .getBrandList()
          .find((el) => el.id == admin_brand_id);
        if (brandPermission) {
          this.$store.dispatch("setCurrentBrandID", admin_brand_id);
        } else {
          this.$store.dispatch(
            "setCurrentBrandID",
            this.$store.getters.getBrandList()[0].id
          );
          this.$router.replace({
            path: this.firstPathFromPermission,
            query: { brandID: this.$store.getters.getBrandList()[0].id },
          });
        }
      }
    },
    checkRouter() {
      var routePrevent = ["Product"];
      if (routePrevent.includes(this.$route.name)) {
        this.isUseClass = false;
      } else {
        this.isUseClass = true;
      }
    },
    getDataProfile: function () {
      var admin_token = this.$cookies.get("tnl-session-token");
      if (admin_token) {
        this.axios.get(`${this.$baseUrl}/user`).then((res) => {
          res.detail.token = admin_token;
          this.$store.dispatch("setUserData", res.detail);

          // let currentBrandID = this.$route.query.brandID;
          // let permissionListByBrandId = res.detail.permissions.filter((el) => {
          //   return el.brandId == currentBrandID;
          // });

          // if(permissionListByBrandId.length > 0) 
          // {
          //   this.$router.options.routes[3].children.forEach((element) => {
          //     if (this.firstPathFromPermission === "/welcome" && permissionListByBrandId[0].permission.indexOf( element.permission ) != -1) {
          //       this.firstPathFromPermission = `/${element.path}`;
          //     }
          //   });
          // }
        });
        this.getBrandList();
      }
      this.setTimeStapm();
    },
    getBrandList: function () {
      var admin_brand_id = this.$route.query.brandID;
      this.axios.get(`${this.$baseUrl}/brand/list`).then((res) => {
        if (res.result) {
          this.$store.dispatch("setBrandList", res.detail);
          if (!admin_brand_id) {
            this.$store.dispatch(
              "setCurrentBrandID",
              this.$store.getters.getBrandList()[0].id
            );
            this.$router.replace({
              path: this.firstPathFromPermission,
              query: { brandID: this.$store.getters.getBrandList()[0].id },
            });
          } else {
            let brandPermission = this.$store.getters
              .getBrandList()
              .find((el) => el.id == admin_brand_id);
            if (brandPermission) {
              this.$store.dispatch("setCurrentBrandID", admin_brand_id);
            } else {
              this.$store.dispatch(
                "setCurrentBrandID",
                this.$store.getters.getBrandList()[0].id
              );
              this.$router.replace({
                path: this.firstPathFromPermission,
                query: { brandID: this.$store.getters.getBrandList()[0].id },
              });
            }
          }
        }
      });
    },
    setTimeStapm() {
      this.$store.watch(
        (state) => {
          return this.isLoading();
        },
        (val) => {
          if (!this.isLoading()) {
            setTimeout(() => {
              this.onload = false;
            }, 1000);
          }
        },
        {
          deep: true,
        }
      );
    },
  },
  created: function () {
    this.getDataProfile();
    //this.getDataMockup();
    this.checkRouter();
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
::v-deep .b-overlay div:last-child {
  top: calc(50vh) !important;
  left: 50% !important;
  transform: unset !important;
}
</style>
